/**
 * @description 刷新预览资源并打开解析后的地址。需要异步刷新时，会在点击事件中
 * 预先创建窗口，避免刷新完成后再打开新窗口被浏览器拦截。
 * @param {Object} options - 预览参数
 * @param {*} options.source - 原始资源
 * @param {boolean} [options.shouldRefresh=false] - 是否刷新资源
 * @param {Function} [options.refreshSource] - 刷新资源的方法
 * @param {Function} options.resolvePreviewUrl - 解析预览地址的方法
 * @param {Function} [options.openUrl] - 无需预开窗口时的地址打开方法
 * @returns {Promise<{source: *, previewUrl: string, opened: boolean}>}
 */
export async function openResolvedPreview({
  source,
  shouldRefresh = false,
  refreshSource,
  resolvePreviewUrl,
  openUrl,
}) {
  const canRefresh = shouldRefresh && typeof refreshSource === 'function'
  const canOpenWindow = typeof window !== 'undefined'
  const previewWindow = canRefresh && canOpenWindow ? window.open('', '_blank') : null

  try {
    const resolvedSource = canRefresh ? (await refreshSource(source)) || source : source
    const previewUrl = resolvePreviewUrl(resolvedSource) || ''

    if (!previewUrl || !canOpenWindow) {
      previewWindow?.close()
      return { source: resolvedSource, previewUrl, opened: false }
    }

    if (previewWindow) {
      previewWindow.opener = null
      previewWindow.location.href = previewUrl
    } else if (typeof openUrl === 'function') {
      openUrl(previewUrl)
    } else {
      window.open(previewUrl, '_blank', 'noopener,noreferrer')
    }

    return { source: resolvedSource, previewUrl, opened: true }
  } catch (error) {
    previewWindow?.close()
    throw error
  }
}
